import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.groups')
  .service('groupsAPI', GroupsAPI);

function GroupsAPI(): BringozApi {
  return {
    base: `/groups`,
    infiniteScroll: {
      address: `/groups`,
      cmd: 'GET'
    },
    actions: {
      createGroup: {
        address: '',
        cmd: 'PUT'
      },
      editGroup: {
        address: '{groupId}',
        cmd: 'POST'
      },
      getTotalGroups: {
        address: 'totals',
        cmd: 'GET',
        updateable: true
      },
      deleteGroup: {
        address: '{groupId}',
        cmd: 'DELETE'
      },
      addBranchesToGroup: {
        address: '{groupId}/branches',
        cmd: 'POST'
      }
    }
  }
}
